import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const FMS00Table: GenericTableSchemaInterface = {
  id: "fms-00",
  name: "FMS 00",
  description: "This table contains data regarding FMS integration success.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "FMS Start"
    },
    c04: {
      name: "Facility ID Set"
    },
    c05: {
      name: "Facility ID Not Set"
    },
    c06: {
      name: "Facility ID Collected"
    },
    c07: {
      name: "FMS Lead Status"
    },
    c08: {
      name: "Not Sent to FMS"
    },
    c09: {
      name: "Tag"
    },
    c10: {
      name: "Persona"
    },
    c11: {
      name: "Tenant Found"
    },
    c12: {
      name: "FMS Error"
    }
  }
};
